<template>
    <div class="success-curtain flex">
        <div class="desktop flex">
        <presentation />
        <div class="right-portion text-center">
            <img src="../../assets/FrontPage/success.svg" alt="" class="mb-3">
            <h3 class="--font"> Just one more step from our side now and we’re taking care of it asap! </h3>
            <p class="secondary-font">You have successfully created your account. Our business team is looking into it & will get in touch with you shortly through your email.</p>
            <button class="--weight" v-ripple @click="$store.dispatch('mainStore/logoutUser')">Logout</button>
        </div>
    </div>
    <div class="mobileview">
        <accountCreated />
    </div>
        
    </div>
</template>

<script>
import accessToken from '../../helpers/accessToken';
import krishfyPresentation from "./components/krishify-presentation.vue";
import API_URL from "../../helpers/apiUrls";
import accountCreated from "../../views/AccountCreated/AccountCreated.vue"

export default {
    name : "successCurtain",

    data() {
        return {
            interval : null
        }
    },

    created() {
        this.getProfileDetails();
    },

    methods : {
         getProfileDetails() {
            const successHandler = response => {
                if(response.status === 200) {
                   if(response.data.verification_status === 'verified')
                    this.$router.replace({ name : 'createContent' })
                }
            }

            const errorHandler = error => {
                this.showToast("Something went wrong internally!", "error", 10000);
                console.log(error);
            }

            const brandID = accessToken.getCredentials().brandID;

            const headers = {
                'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
                'BRAND-ID' : brandID 
            }

            this.requestGET(
                `${API_URL.brand}/${brandID}/_retrieve`,
                {},
                headers,
                successHandler,
                errorHandler
            )
        },
    },

    components : {
        'presentation' : krishfyPresentation,
        'accountCreated':accountCreated
    }
}
</script>

<style lang="scss" scoped>

.right-portion {
    width: 100%;
    padding: 0 15px;
}
.desktop{
    @media all and (max-width: 1024px) {
        display: none;
      }
}
.mobileview{
    @media all and (min-width: 1025px) {
        display: none;
      }

}
button {
    color: rgb(228, 66, 66);
    background-color: rgb(243, 231, 231);
    padding: 10px;
    border-radius: 4px;
}

@media all and (min-width : 1000px) {
    .right-portion {
        width: 35%;
    }
}
</style>